import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'bdb-timer',
    templateUrl: './bdb-timer.component.html',
    styleUrls: ['./bdb-timer.component.scss']
})
export class BbdbTimerComponent implements OnInit {
    @Output('timeOut') timeOut = new EventEmitter();
    minute;
    second;
    showTime;
    actualTime;
    time;
    color;
    strokeDashoffset;
    red;
    green;
    blue;
    private interval;

    constructor() {}

    run() {
        this.minute = 2;
        this.second = 59;
        this.showTime = '2:59';
        this.actualTime = 180;
        this.time = 180;
        this.color = 'rgb(111,219,0)';
        this.strokeDashoffset = 0;
        this.red = 0;
        this.green = 255;
        this.blue = 0;
        if (this.interval) {
            clearInterval(this.interval);
        }
        let i = 0;
        this.interval = setInterval(() => {
            i++;
            const step = (this.green - this.red) / (this.time / 2);
            const step2 = (this.green - this.red) / 20;
            this.strokeDashoffset = i * 440 / this.time;
            this.actualTime--;
            this.second--;
            if (this.second < 0) {
                this.second = 59;
                this.minute--;
            }
            this.showTime = this.minute + ':' + this.second;
            if (this.second < 10) {
                this.showTime = this.minute + ':' + '0' + this.second;
            }
            if (this.minute === 0) {
                this.showTime = '' + this.second;
            }

            if (i >= 30) {
                if (this.green <= 0) {
                    this.green = 0;
                } else {
                    this.green -= step2;
                }
            } else {
                this.red += step;
            }
            this.color = 'rgb(' + Math.round(this.red) + ',' + Math.round(this.green) + ',' + Math.round(this.blue) + ')';
            if (i === this.time) {
                this.showTime = '0';
                this.timeOut.emit();
                clearInterval(this.interval);
            }
        }, 1000);
    }

    ngOnInit() {
        this.run();
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-timer/bdb-timer.component.ts